import { FC, useEffect, useState } from "react";
import { Wrapper } from "./styled";
import { setIntoLocalStorage, getFromLocalStorage } from "./lib/utils";
import Header from "./ui/Header";
import EmployeesTabs from "./ui/EmployeesTabs";
import Table from "./ui/Table";
import SelectedEmployee from "./ui/SelectedEmployee";
import Footer from "./ui/Footer";
import axios, { all } from "axios";

const url = process.env.REACT_APP_API_URL + "api/Child/GetChilds";

const EmployeesTable: FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [tab, setTab] = useState(
    getFromLocalStorage("tab") ? Number(getFromLocalStorage("tab")) : 0
  );
  const [selectedEmployees, setSelectedEmployees] = useState<
    {
      birthdate: string;
      id: number;
      name: string;
      patronimyc: string;
      phoneNumber: string;
      surname: string;
    }[]
  >(
    getFromLocalStorage("selectedEmployees")
      ? JSON.parse(String(getFromLocalStorage("selectedEmployees")))
      : []
  );
  const [menuItem, setMenuItem] = useState(
    getFromLocalStorage("menuItem")
      ? String(getFromLocalStorage("menuItem"))
      : ""
  );

  const handleMenuItem = (menuItem: string) => setMenuItem(menuItem);

  useEffect(() => {
    setIntoLocalStorage("tab", tab);
  }, [tab]);

  useEffect(() => {
    setTab( selectedEmployees.length);
    setIntoLocalStorage("selectedEmployees", JSON.stringify(selectedEmployees));
  }, [selectedEmployees]);

  useEffect(() => {
    setIntoLocalStorage("menuItem", menuItem);
  }, [menuItem]);

  const [children, setChildren] = useState<
  {
    birthdate: string;
    id: number;
    name: string;
    patronimyc: string;
    phoneNumber: string;
    surname: string;
  }[]
>([]);

useEffect(() => {
setIsLoading(true);

axios
  .post(
    url,
    { name: "", skip: 0, sortType: "", take: all },
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  )
  .then((res) => {
    setChildren(res.data.data);
    setIsLoading(false);
  })
  .catch((error) => {
    console.log("error: ", error);
    setIsLoading(false);
  });
}, []);

  return (
    <Wrapper>
      <Header />
      <EmployeesTabs
        tab={tab}
        setTab={setTab}
        selectedEmployees={selectedEmployees}
        setSelectedEmployees={setSelectedEmployees}
      />
      {tab === 0 ? (
        <Table
          selectedEmployees={selectedEmployees}
          setSelectedEmployees={setSelectedEmployees}
          {...{isLoading, children} }
        />
      ) : (
        <SelectedEmployee
          handleMenuItem={handleMenuItem}
          selectedEmployees={selectedEmployees}
          tab={tab}
          menuItem={menuItem}
        />
      )}
      <Footer count={children.length}/>
    </Wrapper>
  );
};

export default EmployeesTable;
